// extracted by mini-css-extract-plugin
export default {"button":"Io-z","reviewSort":"Jo-z"};